import { Injectable } from '@angular/core';
import { Facebook } from '@awesome-cordova-plugins/facebook';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FacebookMarketingService {
  public initialize(): void {
    if (environment.production) {
      this.initializeFacebookAnalytics();
    }
  }

  private initializeFacebookAnalytics(): void {
    Facebook.setAdvertiserTrackingEnabled(true);
    Facebook.setAdvertiserIDCollectionEnabled(true);
    Facebook.setAutoLogAppEventsEnabled(true);
  }
}
